// removed by extract-text-webpack-plugin
module.exports = {"vpHide":"vpHide___2kpuR","vpQuestionPreviewTitle":"vpQuestionPreviewTitle___3MGwu","vpQuestionPreviewHeader":"vpQuestionPreviewHeader___dxNwT","vpTogglePreview":"vpTogglePreview___2Ivj3","vpCursorPointer":"vpCursorPointer___2HtNe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/QuestionPreview.module.less
// module id = 3456
// module chunks = 31